import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Users, Video, Trophy, Target } from "lucide-react";
import { GAEventTrack } from "../../utils/hooks/GA_events";
import { auth } from "../../config/firebaseConfig";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    "/img/ai-lab/hero_coding.jpg",
    "/img/ai-lab/hero-1.jpg",
    "/img/ai-lab/hero-2.jpg",
    "/img/ai-lab/hero-3.jpg",
  ];

  const slideAlts = [
    "Kids learning coding and programming at Practido Learning Center Panipat",
    "Students building robots in robotics classes at Practido Learning Center",
    "Children working on STEM projects at Practido learning lab",
    "Kids exploring Artificial Intelligence and future technology skills in classroom"
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="section hero hero-gradient-bg" id="hero">
      <div className="container">
        <div className="hero-grid">
          {/* Left Hero Content */}
          <div className="hero-content reveal-triggered fade-left active" data-aos="fade-right" data-aos-duration="1000">
            <div className="badge hero-badge" data-aos="zoom-in" data-aos-delay="100">
              <span>🚀</span> India's Leading AI Education Platform
            </div>
            <h1 data-aos="fade-right" data-aos-delay="200">AI, Robotics, Coding &<br /><span>Future Skills Classes for Kids</span></h1>
            <div className="hero-supporting-line" data-aos="fade-right" data-aos-delay="300">Learn. Build. Create. Innovate.</div>
            <p data-aos="fade-right" data-aos-delay="350">Hands-on courses in Artificial Intelligence, Robotics, Coding, STEM, Design, Video Editing and Future Skills for students aged 6-18.</p>
            <p data-aos="fade-right" data-aos-delay="400">Prepare your child for the future with project-based learning designed to build creativity, problem-solving, innovation and technology skills.</p>

            <div className="hero-buttons" data-aos="zoom-in" data-aos-delay="450">
              <a href="#courses" className="btn primary-btn">
                <Sparkles className="mr-1" size={16} strokeWidth={2.5} />
                Explore Courses
              </a>

              <Link
                to={auth?.currentUser ? "/dashboard?type=book-robotics-lab-demo" : "/register?type=book-robotics-lab-demo"}
                className="btn blue-btn"
                onClick={() => GAEventTrack({ event: "book_free_demo_click", data: { location: "hero" } })}
              >
                Book Free Demo
              </Link>
            </div>

            {/* Bottom Left Stats Row */}
            <div className="hero-stats-row" data-aos="fade-up" data-aos-delay="500">
              <div className="stat-card">
                <div className="stat-icon" style={{ backgroundColor: "rgba(139, 92, 246, 0.08)", color: "var(--accent-purple)" }}>
                  <Users size={18} strokeWidth={2.5} />
                </div>
                <div className="stat-number">20K+</div>
                <div className="stat-label">Students</div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ backgroundColor: "rgba(59, 130, 246, 0.08)", color: "var(--accent-blue)" }}>
                  <Sparkles size={18} strokeWidth={2.5} />
                </div>
                <div className="stat-number">AI</div>
                <div className="stat-label">Powered Learning</div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ backgroundColor: "rgba(139, 92, 246, 0.08)", color: "var(--accent-purple)" }}>
                  <Video size={18} strokeWidth={2.5} />
                </div>
                <div className="stat-number">Live</div>
                <div className="stat-label">Classes</div>
              </div>

              <div className="stat-card">
                <div className="stat-icon" style={{ backgroundColor: "rgba(139, 92, 246, 0.08)", color: "var(--accent-purple)" }}>
                  <Trophy size={18} strokeWidth={2.5} />
                </div>
                <div className="stat-number">Project</div>
                <div className="stat-label">Based</div>
              </div>
            </div>
          </div>

          {/* Right Hero Media */}
          <div className="hero-media reveal-triggered fade-right delay-200 active" data-aos="fade-left" data-aos-duration="1000">
            <div className="hero-img-wrap">
              <div className="hero-carousel-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {slides.map((src, index) => (
                  <img key={index} src={src} alt={slideAlts[index]} />
                ))}
              </div>
              <div className="carousel-dots">
                {slides.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${currentSlide === index ? "active" : ""}`}
                    onClick={() => setCurrentSlide(index)}
                  ></span>
                ))}
              </div>
            </div>
            {/* Floating Overlay success rate card */}
            <div className="floating-overlay-card zoom-in active" data-aos="zoom-in" data-aos-delay="400">
              <div className="floating-overlay-icon">
                <Target size={22} strokeWidth={2.5} />
              </div>
              <div className="floating-overlay-text">
                <h4>98% Success Rate</h4>
                <p>Student Projects</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
